
export interface IExceptionInfo {
    type: string;
    message: string;
    stackTrace?: string;
    innerException: IExceptionInfo;
}
export interface IErrorDetails {
    statusCode: number;
    statusText: string;
    exception: IExceptionInfo;
}
export class ErrorUtil {
    /**
     * Checks if the supplied object is an error
     * https://www.typescriptlang.org/docs/handbook/advanced-types.html#using-type-predicates
     * @param error 
     */
    static isError(error:any) :error is Error {
        return (error as Error).message!==undefined;
    }
    static toString(error: IErrorDetails|Error|string): string {
        var msg: string = "Unknown";
        if(typeof error === 'string') return error;
        if(this.isError(error)) return error.message;
        if (error) {
            if (error.exception) {
                msg = error.exception.message;
            } else {
                msg = error.statusCode + " - " + error.statusText;
            }
        }
        return msg;
    }
}
